import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { setupGlobalErrorHandlers } from "./components/error-boundary";
import { prefetchCriticalRoutes } from "./hooks/use-route-prefetch";
import { initSentry } from "./lib/sentry";

// Initialize Sentry before other error handlers
initSentry();

setupGlobalErrorHandlers();
prefetchCriticalRoutes();

// Report Core Web Vitals metrics
if (import.meta.env.PROD) {
  import('./lib/web-vitals').then(({ reportWebVitals }) => {
    reportWebVitals();
  });
}

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
} else if ('serviceWorker' in navigator && import.meta.env.DEV) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}

createRoot(document.getElementById("root")!).render(<App />);
